<template>
  <div class="voucher-extension__tile">
    <div class="voucher-extension__option">
      <span class="keyboard-checkbox__input">
        <input :value="true" class="keyboard-checkbox--checked" type="radio" />
        <span
          class="keyboard-checkbox__control keyboard-checkbox__control--large keyboard-checkbox__control--radio"
        >
          <span class="keyboard-checkbox__radio-dot" />
        </span>
      </span>
      <div class="voucher-extension__option-info">
        <p class="voucher-extension__option-name">90 Day Voucher Extension</p>
        <p v-if="certificateName" class="voucher-extension__option-certificate">
          {{ certificateName }}
        </p>
      </div>
      <div>
        <p class="voucher-extension__option-price">$100</p>
      </div>
    </div>
    <p class="voucher-extension__description">
      Your voucher will be extended 90 days from the current expiration. <br />
      <span v-if="showWarning" class="voucher-extension__description-warning"
        >Voucher extension will be processed to your account within 2 business
        days.
      </span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'VoucherExtensionTile',
  props: {
    showWarning: {
      type: Boolean,
      default: false,
    },
    certificateName: {
      type: String,
      required: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.voucher-extension {
  &__tile {
    padding: 10px;
    border-radius: 12px;
    background: var(--glass-mid-gray);

    cursor: pointer;
    
    @include desktop {
      padding: 10px 20px;
    }
  }
  &__option {
    display: flex;
    align-items: center;
    gap: 15px;

    &-info {
      flex: 1;
    }
    &-name {
      margin: 0;

      color: var(--white);
      font-feature-settings: 'clig' off, 'liga' off;

      font-size: 1.125rem;
      font-style: normal;
      font-weight: 500;
      line-height: 1.5rem;
    }
    &-certificate {
      display: none;
      margin: 0;

      color: var(--light-blue-gray);
      font-feature-settings: 'clig' off, 'liga' off;

      font-size: 0.875rem;
      font-style: normal;
      font-weight: 450;
      line-height: 1.25rem;

      @include desktop {
        display: initial;
      }
    }

    &-price {
      margin: 0;

      color: var(--white);
      font-feature-settings: 'clig' off, 'liga' off;

      font-size: 1.5rem;
      font-style: normal;
      font-weight: 700;
      line-height: 2rem;
    }
  }
  &__description {
    margin: 15px 0 0 0;

    font-feature-settings: 'clig' off, 'liga' off;

    font-size: 0.75rem;
    font-style: normal;
    font-weight: 450;
    line-height: 0.875rem; /* 116.667% */

    color: var(--dusty-gray);

    @include desktop {
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 450;
      line-height: 1.25rem;
    }
  }
}
.keyboard-checkbox {
  &__control {
    &--large {
      width: 30px;
      height: 30px;
    }
  }
}
</style>
